import * as React from "react";
import { useRef, useState } from "react";
import { DateTime } from "luxon";
import { CircularProgress } from "@mui/material";
import QueryDataTable from "../../components/QueryDataTable";
import { dateFilterColumn } from "../../components/DataTable";
import { useInterval } from "../../hooks/useInterval";

const REPORT_TYPE = "rt_levels_new";
const RT_LEVELS_REFRESH_TIME = 30 * 1000;

const COLUMNS = [
    dateFilterColumn("available_from", "Available From", {
        dateFormat: "dd/MM/yyyy HH:mm",
    }),
];

const INITIAL_QUERY = { report_type: REPORT_TYPE };

const formatCSVFilename = () => `report-${REPORT_TYPE}.csv`;

export default function RTLevels() {
    const queryDataTable = useRef();
    const [lastUpdated, setLastUpdated] = useState(null);
    const [isRefreshing, setIsRefreshing] = useState(false);

    // Silently reload the report every 30 seconds
    useInterval(async () => {
        setIsRefreshing(true);
        try {
            await queryDataTable.current?.refreshResults({ silent: true });
        } catch (e) {
            console.error("Failed to refresh real-time levels", e);
        } finally {
            setIsRefreshing(false);
        }
    }, RT_LEVELS_REFRESH_TIME);

    return (
        <>
            <QueryDataTable
                actions={
                    <div className="flex items-center gap-2 text-sm text-gray-500">
                        {isRefreshing && <CircularProgress size={14} color="inherit" />}
                        <span>
                            Auto-refreshes every {RT_LEVELS_REFRESH_TIME / 1000}s
                            {lastUpdated &&
                                ` · Last updated ${lastUpdated.toFormat("HH:mm:ss")}`}
                        </span>
                    </div>
                }
                ref={queryDataTable}
                tableColumns={COLUMNS}
                showAllColumns={true}
                queryAPIPath="report"
                initialQuery={INITIAL_QUERY}
                dynamicLoad={true}
                formatCSVFilename={formatCSVFilename}
                onResults={() => setLastUpdated(DateTime.now())}
            />
        </>
    );
}
